import type { Nullable } from '@clearverify/types';

export enum AddressFieldsFormFields {
  street = 'street',
  city = 'city',
  county = 'county',
  state = 'state',
  zipCode = 'zipCode',
}

export type AddressFieldsFormValues = {
  [AddressFieldsFormFields.street]?: Nullable<string>;
  [AddressFieldsFormFields.city]?: Nullable<string>;
  [AddressFieldsFormFields.county]?: Nullable<string>;
  [AddressFieldsFormFields.state]?: Nullable<string>;
  [AddressFieldsFormFields.zipCode]?: Nullable<string>;
};
